import { OpenAPIConfig, Platform } from "../generated"
import { createAxiosHttpRequest, AxiosRetryConfig } from "./createAxiosHttpRequest"

export const platform = (TOKEN: () => Promise<string>, retryConfig?: AxiosRetryConfig): Platform => {
  const config: Partial<OpenAPIConfig> = {
    BASE: `https://api.${getAppEnvFromUrl()}.infra.flockcover.com`,
    TOKEN,
  }

  const request = retryConfig ? createAxiosHttpRequest(retryConfig) : undefined

  return new Platform(config, request)
}

// @Hack fallback
const getAppEnvFromUrl = () => {
  if (window.location.origin.includes(`dev`)) {
    return `dev`
  }

  if (window.location.origin.includes(`staging`) || window.location.origin.includes(`localhost`)) {
    return `staging`
  }

  // ORDERING is important!
  if (window.location.origin.includes(`ui.prod.infra.flockcover.com`)) {
    return `prod`
  }

  throw new Error(`Can not build correctly without an application environment`)
}
